// @flow

import roundTo from '../roundTo';
import { DISPLAY_YEARLY } from '../../store/productTypeSettings/constants';

export default (mileage: number, label: string, mileageDisplayType: string) => {
  if (mileageDisplayType === DISPLAY_YEARLY) {
    return `${roundTo(mileage * 12).toLocaleString('nl-NL')} ${label}`;
  }
  return `${mileage.toLocaleString('nl-NL')} ${label}`;
};
